<template>
  <form action="" class="form gift-page__form">
    <div class="gift-page__form-title" v-html="annotation"></div>
    <template v-if="showPhoneInput">
      <div class="form_row required" :class="{ 'error': $v.phone.$error }">
        <label><span>Телефон</span><span class="req">*</span></label>
        <input class="form-control" type="text" :key="1" name="phone" @blur="setPhone" value="" >
      </div>
      <div class="form__submit">
        <input @click.prevent="sendSms" type="submit" value="Отправить" class="btn btn_blue">
      </div>
    </template>

    <template v-else-if="showCodeInput">
      <div class="form_row required" :class="{ 'error': $v.code.$error }">
        <label><span>Введите код подтверждения</span><span class="req">*</span></label>
        <input v-focus class="form-control" type="text" :key="2" v-model="code"  name="code" value="" maxlength="100">
      </div>
      <div class="form__submit">
        <input @click.prevent="verify" type="submit" value="Отправить" class="btn btn_blue">
      </div>
    </template>

    <template v-else-if="showEmailInput">
      <div class="form_row required" :class="{ 'error': $v.email.$error }">
        <label><span>E-mail</span><span class="req">*</span></label>
        <input v-focus class="form-control" type="email" :key="3" name="email" v-model="email" maxlength="100" value="">
      </div>
      <div class="form__submit">
        <input type="submit" @click.prevent="bindEmail" value="Активировать карту" class="btn btn_red">
      </div>
    </template>

    <template v-else-if="showPasswordForm">
      <div class="form_row required" :class="{ 'error': $v.passwordRepeat.$error }">
        <label><span>Пароль:</span><span class="req">*</span></label>
        <input v-focus class="form-control" type="password" :key="4" name="password" v-model="password" maxlength="100" value="">
      </div>
      <div class="form_row required" :class="{ 'error': $v.passwordRepeat.$error }">
        <label><span>Повторите пароль:</span><span class="req">*</span></label>
        <input class="form-control" type="password" :key="5" name="passwordRepeat" v-model="passwordRepeat" maxlength="100" value="">
      </div>
      <div class="form_message" v-if="!$v.password.minLength">Минимальная длина пароля 6 символов</div>
      <div class="form_message" v-else-if="!$v.passwordRepeat.sameAsPassword && $v.passwordRepeat.$error">Пароли не совпадают</div>
      <div class="form__submit">
        <input type="submit" @click.prevent="setPassword" value="Установить пароль" class="btn btn_red">
      </div>
    </template>

    <gift-popup v-if="modal.show" :message="modal.message"></gift-popup>
  </form>
</template>

<script>
import {required, minLength, maxLength, email, sameAs, numeric} from 'vuelidate/lib/validators'

export default {
  name: "ActivateForm",
  props: {
    description: {
      type: String,
      default: '',
    },
    cardKey: {
      type: String,
      required: true,
    },
    needSms: {
      type: Boolean,
      default: true,
    },
    needEmail: {
      type: Boolean,
      default: true,
    }
  },
  data()
  {
    return {
      annotation: '',
      step: 1,
      phone: '',
      modal: {
        show: false,
        message: '',
      },
      code: '',
      email: '',
      password: '',
      passwordRepeat: '',
    }
  },
  directives:{
    focus:{
      inserted: function ( el )
      {
        el.focus()
      }
    }
  },
  mounted()
  {
    this.annotation = this.description;
    if(this.needSms)
    {
      this.step = 1;
    }
    else if(this.needEmail)
    {
      this.step = 3;
    }
    else
    {
      this.step = 4;
    }
  },
  computed: {
    showPhoneInput()
    {
      return this.step === 1;
    },
    showCodeInput()
    {
      return this.step === 2;
    },
    showEmailInput()
    {
      return this.step === 3;
    },
    showPasswordForm()
    {
      return this.step === 4;
    }
  },
  validations() {
    if(this.step === 1)
    {
      return {
        phone: {
          required,
          minLength: minLength(11),
          maxLength: maxLength(11),
        },
      }
    }
    else if(this.step === 2)
    {
      return {
        code: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4),
        },
      }
    }
    else if(this.step === 3)
    {
      return {
        email: {
          required,
          email,
        },
      }
    }
    else if(this.step === 4)
    {
      return {
        password: {
          required,
          minLength: minLength(6)
        },
        passwordRepeat: {
          required,
          sameAsPassword: sameAs('password')
        },
      }
    }
  },
  methods:
  {
    setPhone(e)
    {
      this.phone = e.target.value.match(/\d/g).join('');
    },
    sendSms()
    {
      this.$v.$touch();
      if(this.$v.$invalid)
      {
        return;
      }

      let fd = new FormData;
      fd.append('phone', this.phone);
      fd.append('key', this.cardKey);
      fetch(`/api/gift-cards/activate/sms/`, {
        method: 'POST',
        body: fd,
      }).then(response => response.json())
      .then( json => {
        if(json.success)
        {
          this.step = 2;
          this.annotation = json.data.annotation;
        }
        else
        {
          this.showModal(json.message);
        }
      })
    },
    verify()
    {
      this.$v.$touch();
      if(this.$v.$invalid)
      {
        return;
      }

      let fd = new FormData;
      fd.append('key', this.cardKey);
      fd.append("code", this.code);
      fetch('/api/gift-cards/activate/verify/', {
        method: 'POST',
        body: fd,
      }).then(response => response.json())
      .then(json => {
        if(json.success)
        {
          this.step = 3;
          this.annotation = json.data.annotation;
        }
        else
        {
          this.showModal(json.message);
        }
      })
    },
    bindEmail()
    {
      this.$v.$touch();
      if(this.$v.$invalid)
      {
        return;
      }

      let fd = new FormData;
      fd.append('key', this.cardKey);
      fd.append("email", this.email);
      fetch('/api/gift-cards/activate/bind-email/', {
        method: 'POST',
        body: fd,
      }).then(response => response.json())
          .then(json => {
            if(json.success)
            {
              if(json.data['need-register'])
              {
                this.annotation = json.data.annotation;
                this.step = 4;
              }
              else
              {
                window.location.reload();
              }
            }
            else
            {
              this.showModal(json.message);
            }
          })
    },
    setPassword()
    {
      this.$v.$touch();
      if(this.$v.$invalid)
      {
        return;
      }

      let fd = new FormData;
      fd.append('key', this.cardKey);
      fd.append('password', this.password);
      fd.append('passwordRepeat', this.passwordRepeat);
      fetch('/api/gift-cards/activate/register/', {
        method: 'POST',
        body: fd,
      }).then(response => response.json())
      .then(json => {
        if(json.success)
        {
          window.location.reload();
        }
        else
        {
          this.showModal(json.message);
        }
      })
    },
    showModal(message)
    {
      this.modal.show = true;
      this.modal.message = message;
    }
  }
}
</script>